import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	redactions: {
		id: 'issue.action-menu.redactions',
		defaultMessage: 'Redactions',
		description: 'Label for the redactions actions item which opens redaction table',
	},
});
